/*
  Customer video strip.

  Videos are muted and looping so they can autoplay, which browsers only allow
  while muted. Playback is tied to visibility so a product page with six clips
  does not decode all of them at once, and unmuting one mutes the rest.
*/
if (!customElements.get('ugc-videos')) {
  customElements.define(
    'ugc-videos',
    class UgcVideos extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        if (!this.videos.length) return;

        this.videos.forEach(function (video) {
          // Required for inline autoplay on iOS.
          video.muted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.playsInline = true;
          video.loop = true;
          video.controls = false;
          video.removeAttribute('controls');
        });

        this.bindMuteButtons();
        this.observeVisibility();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      bindMuteButtons() {
        var self = this;
        this.querySelectorAll('[data-ugc-mute]').forEach(function (button) {
          button.addEventListener('click', function () {
            var item = button.closest('.ugc-videos__item');
            var video = item && item.querySelector('video');
            if (!video) return;

            var willUnmute = video.muted;
            // Only one clip plays audio at a time.
            if (willUnmute) self.muteAll();

            video.muted = !willUnmute;
            button.setAttribute('aria-pressed', String(video.muted));
            if (willUnmute) {
              var play = video.play();
              if (play && play.catch) play.catch(function () {});
            }
          });
        });
      }

      muteAll() {
        this.videos.forEach(function (video) {
          video.muted = true;
        });
        this.querySelectorAll('[data-ugc-mute]').forEach(function (button) {
          button.setAttribute('aria-pressed', 'true');
        });
      }

      observeVisibility() {
        if (!('IntersectionObserver' in window)) {
          this.videos.forEach(function (video) {
            var play = video.play();
            if (play && play.catch) play.catch(function () {});
          });
          return;
        }

        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                var play = video.play();
                if (play && play.catch) play.catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.25 }
        );

        var observer = this.observer;
        this.videos.forEach(function (video) {
          observer.observe(video);
        });
      }
    }
  );
}
